import { render, staticRenderFns } from "./Pluses.vue?vue&type=template&id=5380b676&"
import script from "./Pluses.vue?vue&type=script&lang=js&"
export * from "./Pluses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports